import { EventEmitter } from 'events';
export default class Evented extends EventEmitter {
    constructor() {
        super(...arguments);
        this.internalEventListeners = [];
    }
    listenTo(target, event, handler) {
        this.internalEventListeners.push({ target, event, handler });
        target.on(event, handler);
    }
    stopListening(target, event, handler) {
        let i = 0;
        while (i < this.internalEventListeners.length) {
            const listener = this.internalEventListeners[i];
            if ((!target || listener.target === target) &&
                (!event || listener.event === event) &&
                (!handler || listener.handler === handler)) {
                listener.target.removeListener(listener.event, listener.handler);
                this.internalEventListeners.splice(i, 1);
            }
            else {
                i++;
            }
        }
    }
}
//# sourceMappingURL=Evented.js.map